import { VirtualBackgroundManager } from 'utils/webrtc/virtual-background/VirtualBackgroundManager';

export const useVirtualBackground = () => ({
  control: VirtualBackgroundManager,
});
